export const NB: Record<string, string> = {
  "Home": "Hjem",
      "Resource Selected": "Valgt ressurs",
      "Resources List": "Ressursliste",
      "List": "Liste",
      "Resources": "Ressurser",
      "Find Colleague": "Finn kollega",
      "Settings": "Innstillinger",
      "Floor Plan": "Plantegning",
      "Locations": "Steder",
      "Categories": "Kategorier",
      "Search resource name...": "Søk ressursnavn...",
      "Calendar": "Kalender",
      "View Details": "Vis detaljer",
      "Add to My Favorites": "Legg til i Mine favoritter",
      "Remove": "Fjern",
      "Resource calendar": "Ressurskalender",
      "Today": "I dag",
      "Previous month": "Forrige måned",
      "Next month": "Neste måned",
      "Previous year": "Forrige år",
      "Next year": "Neste år",
      "Close": "Lukk",
      "Field is required.": "Feltet er påkrevd.",
      "Invalid date format.": "Ugyldig datoformat.",
      "S": "Søn",
      "M": "Man",
      "T": "Tir",
      "W": "Ons",
      "F": "Fre",
      "January": "Januar",
      "February": "Februar",
      "March": "Mars",
      "April": "April",
      "May": "Mai",
      "June": "Juni",
      "July": "Juli",
      "August": "August",
      "September": "September",
      "October": "Oktober",
      "November": "November",
      "December": "Desember",
      "Jan": "Jan",
      "Feb": "Feb",
      "Mar": "Mar",
      "Apr": "Apr",
      "Jun": "Jun",
      "Jul": "Jul",
      "Aug": "Aug",
      "Sep": "Sep",
      "Oct": "Okt",
      "Nov": "Nov",
      "Dec": "Des",
      "st": ".",
      "nd": ".",
      "rd": ".",
      "th": ".",
      "Sunday": "Søndag",
      "Monday": "Mandag",
      "Tuesday": "Tirsdag",
      "Wednesday": "Onsdag",
      "Thursday": "Torsdag",
      "Friday": "Fredag",
      "Saturday": "Lørdag",
      "Sun": "Søn",
      "Mon": "Man",
      "Tue": "Tir",
      "Wed": "Ons",
      "Thu": "Tor",
      "Fri": "Fre",
      "Sat": "Lør",
      "Su": "Søn",
      "Mo": "Ma",
      "Tu": "Ti",
      "We": "On",
      "Th": "To",
      "Fr": "Fr",
      "Sa": "Lø",
      "PM": "ettermiddag",
      "AM": "formiddag",
      "You cannot book this resource because your meeting request conflicts with the resource's booking policies.": "Du kan ikke reservere denne ressursen fordi møteforespørselen din er i konflikt med ressursens bestillingsregler.",
      "You need permissions to interact with this resource.": "Du trenger tillatelser for å samhandle med denne ressursen.",
      "Reason": "Årsak",
      "The resource cannot be booked {{day}} days in advanced.": "Ressursen kan ikke bestilles {{day}} dager på forhånd.",
      "The end date of a recurring meeting cannot be more than {{day}} days from today.": "Sluttdatoen for et gjentakende møte kan ikke være mer enn {{day}} dager fra i dag.",
      "Meeting duration cannot be longer than {{time}} minutes long.": "Møteduasjonen kan ikke være lengre enn {{time}} minutter.",
      "Meeting duration cannot be shorter than {{time}} minutes long.": "Møteduasjonen kan ikke være kortere enn {{time}} minutter.",
      "Booking policy": "Bestillingsregler",
      "Available": "Tilgjengelig",
      "Selected": "Valgt",
      "Booked": "Bestilt",
      "Closed": "Stengt",
      "Filter Options": "Filtreringsalternativer",
      "{{resource}} is deleted": "{{resource}} er slettet.",
      "This resource can be booked but any occurrences with conflicts the resource will not be booked.": "Denne ressursen kan bestilles, men eventuelle forekomster med konflikter vil ikke bli bestilt.",
      "This resource can be booked in advance for a maximum of {{day}} days, any occurrences beyond that limit will not be booked": "Denne ressursen kan bestilles på forhånd for maksimalt {{day}} dager, eventuelle forekomster utover denne grensen vil ikke bli bestilt",
      "This resource can be booked, but the meeting duration must be at least {{time}} minutes.": "Denne ressursen kan bestilles, men møteduasjonen må være minst {{time}} minutter.",
      "This resource can be booked, but the meeting duration must not exceed {{time}} minutes.": "Denne ressursen kan bestilles, men møteduasjonen må ikke overstige {{time}} minutter.",
      "Booking this resource requires approval by the resource's delegate. Your request will be forwarded, pending approval.": "For å bestille denne ressursen kreves godkjenning av ressursens delegat. Forespørselen din vil bli sendt videre i påvente av godkjenning.",
      "Resource Name": "Ressursnavn",
      "Description": "Beskrivelse",
      "Resource Mail": "Ressurs-e-post",
      "Location": "Sted",
      "Capacity": "Kapasitet",
      "Language": "Språk",
      "Select an language": "Velg et språk",
      "Date/Time Format": "Dato/klokkeslett-format",
      "First day of the week": "Første dag i uken",
      "Please select a first day": "Vennligst velg en første dag",
      "Please select a time format": "Vennligst velg et klokkeslett-format",
      "Date Format": "Datoformat",
      "Please select a date format": "Vennligst velg et datoformat",
      "Date Separator": "Dato-separator",
      "Please select a date separator": "Vennligst velg en dato-separator",
      "Apply": "Bruk",
      "Default Location": "Standard sted",
      "Clear": "Tøm",
      "Help": "Hjelp",
      "Unavailable": "Ikke tilgjengelig",
      "No data available": "Ingen data tilgjengelig",
      "More": "Mer",
      "Available Floor Plans": "Tilgjengelige plantegninger",
      "Default Categories": "Standardkategorier",
      "List more Resources": "List opp flere ressurser",
      "Attendees": "Deltakere",
      "Click on Further information to visit our support site": "Klikk på Mer informasjon for å besøke vårt supportsenter",
      "New Order": "Ny ordre",
      "Save default categories successfully": "Lagre standardkategorier vellykket",
      "Save config date/time successfully": "Lagre konfigurert dato/klokkeslett vellykket",
      "Save language successfully": "Lagre språk vellykket",
      "Save default location successfully": "Lagre standardplassering vellykket",
      "And": "Og",
  "Or": "Eller",
  "Available occurrences of the series": "Tilgjengelige forekomster av serien",
  "Conflicting Occurrences": "Konflikterende forekomster",
  "Availability": "Tilgjengelighet",
  "Time Format": "Tidsformat",
  "You do not have permission to book this resource.": "Du har ikke tillatelse til å bestille denne ressursen.",
"This resource does not allow booking of recurring meetings.": "Denne ressursen tillater ikke bestilling av gjentatte møter.",
"You cannot book this resource.": "Du kan ikke bestille denne ressursen."
};
